"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var checkAppsStatus = function checkAppsStatus(_ref) {
  var apps = _ref.apps,
      activities = _ref.activities;
  var status = Object.keys(apps).map(function (appName) {
    return apps[appName].status;
  }).filter(function (appStatus) {
    return appStatus !== 'SYNCED';
  });
  activities = Object.keys(apps).reduce(function (result, appName) {
    result = [].concat((0, _toConsumableArray2["default"])(result), (0, _toConsumableArray2["default"])(apps[appName].activities || []));
    return result;
  }, []);
  return {
    status: status,
    activities: activities
  };
};

var _default = checkAppsStatus;
exports["default"] = _default;
//# sourceMappingURL=checkAppsStatus.js.map